/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetUniverseStargatesStargateIdDestination } from './GetUniverseStargatesStargateIdDestination';
import {
    GetUniverseStargatesStargateIdDestinationFromJSON,
    GetUniverseStargatesStargateIdDestinationFromJSONTyped,
    GetUniverseStargatesStargateIdDestinationToJSON,
    GetUniverseStargatesStargateIdDestinationToJSONTyped,
} from './GetUniverseStargatesStargateIdDestination';
import type { GetUniverseStargatesStargateIdPosition } from './GetUniverseStargatesStargateIdPosition';
import {
    GetUniverseStargatesStargateIdPositionFromJSON,
    GetUniverseStargatesStargateIdPositionFromJSONTyped,
    GetUniverseStargatesStargateIdPositionToJSON,
    GetUniverseStargatesStargateIdPositionToJSONTyped,
} from './GetUniverseStargatesStargateIdPosition';

/**
 * 200 ok object
 * @export
 * @interface GetUniverseStargatesStargateIdOk
 */
export interface GetUniverseStargatesStargateIdOk {
    /**
     * 
     * @type {GetUniverseStargatesStargateIdDestination}
     * @memberof GetUniverseStargatesStargateIdOk
     */
    destination: GetUniverseStargatesStargateIdDestination;
    /**
     * name string
     * @type {string}
     * @memberof GetUniverseStargatesStargateIdOk
     */
    name: string;
    /**
     * 
     * @type {GetUniverseStargatesStargateIdPosition}
     * @memberof GetUniverseStargatesStargateIdOk
     */
    position: GetUniverseStargatesStargateIdPosition;
    /**
     * stargate_id integer
     * @type {number}
     * @memberof GetUniverseStargatesStargateIdOk
     */
    stargateId: number;
    /**
     * The solar system this stargate is in
     * @type {number}
     * @memberof GetUniverseStargatesStargateIdOk
     */
    systemId: number;
    /**
     * type_id integer
     * @type {number}
     * @memberof GetUniverseStargatesStargateIdOk
     */
    typeId: number;
}

/**
 * Check if a given object implements the GetUniverseStargatesStargateIdOk interface.
 */
export function instanceOfGetUniverseStargatesStargateIdOk(value: object): value is GetUniverseStargatesStargateIdOk {
    if (!('destination' in value) || value['destination'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('stargateId' in value) || value['stargateId'] === undefined) return false;
    if (!('systemId' in value) || value['systemId'] === undefined) return false;
    if (!('typeId' in value) || value['typeId'] === undefined) return false;
    return true;
}

export function GetUniverseStargatesStargateIdOkFromJSON(json: any): GetUniverseStargatesStargateIdOk {
    return GetUniverseStargatesStargateIdOkFromJSONTyped(json, false);
}

export function GetUniverseStargatesStargateIdOkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUniverseStargatesStargateIdOk {
    if (json == null) {
        return json;
    }
    return {
        
        'destination': GetUniverseStargatesStargateIdDestinationFromJSON(json['destination']),
        'name': json['name'],
        'position': GetUniverseStargatesStargateIdPositionFromJSON(json['position']),
        'stargateId': json['stargate_id'],
        'systemId': json['system_id'],
        'typeId': json['type_id'],
    };
}

export function GetUniverseStargatesStargateIdOkToJSON(json: any): GetUniverseStargatesStargateIdOk {
    return GetUniverseStargatesStargateIdOkToJSONTyped(json, false);
}

export function GetUniverseStargatesStargateIdOkToJSONTyped(value?: GetUniverseStargatesStargateIdOk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'destination': GetUniverseStargatesStargateIdDestinationToJSON(value['destination']),
        'name': value['name'],
        'position': GetUniverseStargatesStargateIdPositionToJSON(value['position']),
        'stargate_id': value['stargateId'],
        'system_id': value['systemId'],
        'type_id': value['typeId'],
    };
}

